import { LeafList } from "./list.component.js";
customElements.define("leaf-list", LeafList);
export {
  LeafList
};
//# sourceMappingURL=list.js.map
